module.exports = __webpack_public_path__ + "img/unchecked-radio.99325435.svg";